import { alpha, Box, ListItemButton } from "@mui/material";
import MuiImage from "mui-image";
import { useContext } from "react";
import useResponsive from "src/hooks/useResponsive";
import palette from "src/theme/palette";
import { ConnectedEntity } from "src/types/apps";
import { entitiesUrl } from "src/utils/formatUrl";

import Context from "../../../context";
import MaintenanceIcon from "../MaintenanceIcon";

// ----------------------------------------------------------------------

type Props = {
	item: ConnectedEntity;
};

const sx = {
	borderRadius: 1,
	m: 1,
	p: 4,
	backgroundColor: "white",
	justifyContent: "center",
	cursor: "pointer",
	boxShadow: 2
};

export const EntityItemBtn = ({ item }: Props) => {
	const { actions, themeType } = useContext(Context);
	const isDesktop = useResponsive("up", "md");
	const isMobile = useResponsive("down", "sm");

	const shadowColor = themeType === "dark" ? "#000000" : palette.light.grey[500];
	const maintenance = item.maintenance;

	return (
		<ListItemButton
			key={item.id}
			onClick={() => (!maintenance ? actions.onSelectEntity(item) : {})}
			disableRipple={maintenance}
			sx={{
				...sx,
				boxShadow: `0 0 2px 0 ${alpha(shadowColor, 0.2)}, 0 12px 24px -4px ${alpha(
					shadowColor,
					0.12
				)}`,
				cursor: maintenance ? "not-allowed" : "pointer",
				backgroundColor: themeType === "dark" ? alpha("#fff", 0.8) : "#fff"
			}}
		>
			{maintenance && <MaintenanceIcon />}
			<Box
				height={isDesktop && !isMobile ? 35 : 73}
				sx={{
					display: "flex",
					overflow: "hidden",
					alignItems: "center",
					justifyContent: "center"
				}}
			>
				<MuiImage
					src={entitiesUrl(item.id)}
					alt={item.name}
					fit='contain'
					duration={500}
					height='auto'
				/>
			</Box>
		</ListItemButton>
	);
};

export default EntityItemBtn;
